// Web-compatible IAP service stub
// For web, you would typically integrate with Stripe or another payment processor
// This is a placeholder that provides the same interface but indicates web payments need to be implemented

class IAPService {
  constructor() {
    this.products = [];
    this.isInitialized = false;
  }

  /**
   * Initialize IAP connection (web stub)
   */
  async initialize() {
    if (this.isInitialized) {
      console.log('✅ IAP already initialized (web mode)');
      return this.products;
    }

    try {
      console.log('⚠️ IAP not available on web. Please implement Stripe or another payment processor.');
      // For web, you would fetch products from your backend/Stripe
      // This is a placeholder
      this.products = [
        {
          productId: 'MONTHLY3000',
          title: 'Monthly Subscription',
          description: 'Monthly subscription to SpacedAI Pro',
          price: '$3.99',
          currency: 'USD',
        },
        {
          productId: 'Yearly3000',
          title: 'Yearly Subscription',
          description: 'Yearly subscription to SpacedAI Pro',
          price: '$29.99',
          currency: 'USD',
        },
      ];
      this.isInitialized = true;
      return this.products;
    } catch (error) {
      console.error('❌ Failed to initialize IAP (web mode):', error);
      throw error;
    }
  }

  /**
   * Set up purchase listeners (web stub)
   */
  setupPurchaseListeners(onPurchaseSuccess, onPurchaseError) {
    console.log('⚠️ Purchase listeners not available on web. Implement Stripe webhooks instead.');
  }

  /**
   * Verify receipt with backend (web stub)
   */
  async verifyReceiptWithBackend(purchase) {
    // For web, you would verify with Stripe or your payment processor
    console.log('⚠️ Receipt verification not implemented for web. Use Stripe webhooks.');
    return { valid: false };
  }

  /**
   * Remove purchase listeners (web stub)
   */
  removePurchaseListeners() {
    console.log('⚠️ Purchase listeners not available on web.');
  }

  /**
   * Request a subscription purchase (web stub)
   */
  async purchaseSubscription(productId) {
    console.log('⚠️ Purchase not available on web. Redirect to Stripe checkout or implement payment flow.');
    // For web, you would redirect to Stripe Checkout or implement a payment modal
    throw new Error('IAP not available on web. Please implement Stripe checkout.');
  }

  /**
   * Restore previous purchases (web stub)
   */
  async restorePurchases() {
    console.log('⚠️ Restore purchases not available on web. Check subscription status from backend.');
    // For web, you would check subscription status from your backend/Firestore
    return [];
  }

  /**
   * Get the current subscription status (web stub)
   */
  async getCurrentSubscription() {
    console.log('⚠️ Get current subscription not available on web. Check Firestore for subscription status.');
    return null;
  }

  /**
   * End IAP connection (web stub)
   */
  async endConnection() {
    console.log('⚠️ IAP connection not available on web.');
    this.isInitialized = false;
  }

  /**
   * Get products list
   */
  getProducts() {
    return this.products;
  }

  /**
   * Get a specific product by ID
   */
  getProduct(productId) {
    return this.products.find(p => p.productId === productId) || null;
  }
}

// Export singleton instance
export default new IAPService();
